<template lang="html">

  <section class="login" v-if="!hideForm">
    <h1>Log In</h1>
    <div class="user-note">
      You must complete your inspection report within 7 days of your move-in. Only one roommate per unit may complete the inspection.
    </div>
    <div class="form-item">
      <select name="property" v-model="property" v-on:change="getUnits" :disabled="!propertiesReady">
        <option value="">Select your Property</option>
        <option v-for="pid in Object.keys(properties)" :key="pid" :value="pid">{{ properties[pid].Name }}</option>
      </select>
    </div>
    <div class="form-item">
      <select name="unit" v-model="unit" :disabled="!unitsReady">
        <option value="">{{ unitPlaceholder }}</option>
        <option v-for="uid in Object.keys(units)" :value="uid">{{ units[uid].Name }}</option>
      </select>
    </div>
    <div class="form-item"><input v-model="lastName" name="lastName" placeholder="LAST NAME"></div>
    <div class="form-item"><input v-model="lastFourOfPhone" inputmode="numeric" pattern="\d*" maxlength="4" name="lastFourOfPhone" placeholder="LAST 4 DIGITS OF PHONE"></div>

    <div><button v-on:click="login" :disabled="needsMoreUserInput">Login</button></div>

  </section>

</template>

<script lang="js">

  import router from '@/router.js';

  export default  {
    name: 'login',
    props: [],
    mounted() {

    },
    data() {
      return {
        propertiesReady : false,
        unitsReady : false,
        units : {},
        property : '',
        unit : '',
        lastName : '',
        lastFourOfPhone : '',
        hideForm : false,
        propertyPlaceholder : 'Loading properties',
        unitPlaceholder : '',
      }
    },
    computed: {
      needsMoreUserInput: function () {
        return this.property.length < 1 || this.unit.length < 1 || this.lastName.length < 1 || this.lastFourOfPhone.length < 1;
      },
      properties : function (){
        if( Object.keys( this.$store.state.properties ).length > 0 ){
          this.propertiesReady = true;
          this.propertyPlaceholder = 'Select your property';
        }
        return this.$store.state.properties;
      },
    },
    methods: {
      login(){
        this.hideForm = true;
        let credentials = {
          property : this.property,
          unit : this.unit,
          lastName : this.lastName,
          lastFourOfPhone : this.lastFourOfPhone
        };
        this.$store.dispatch('login', credentials).then( () => {
          this.$store.dispatch( 'postMessage', { msg : 'Successfully loaded your inspection!', timeout : 3000, allowClose : true });
          router.push('/');
        }).then( () => {
          this.$store.dispatch( 'checkAllCompleted' );
        }).catch( reason => {
            this.$store.dispatch( 'postMessage', { msg : reason, timeout : 15000, allowClose : true });
            this.hideForm = false;
        });

      },
      getUnits(){
        if( this.property == '' ){
          return;
        }
        //commit fetch units message with value of this.property
        this.unitsReady = false;
        this.units = {};
        this.unit = '';
        this.unitPlaceholder = 'Loading units...';
        this.$store.dispatch( 'fetchPropertyUnits', this.property ).then(() => {
          this.unitsReady = true;
          this.updateUnits();
        });

      },
      updateUnits(){
        let fullProperty = this.$store.getters.property( this.property );
        if( fullProperty.hasOwnProperty( 'units' ) ){
          this.units = fullProperty.units;
          this.unitsReady = true;
          this.unitPlaceholder = 'Select your unit';
        }
      }
    }
}
</script>

<style scoped lang="scss">
  .login {

  }
</style>
